import React from "react";
import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Mirande" />
        <footer>
          This page was coded by{" "}
          <a
            href="https://www.linkedin.com/in/nadegerey32/"
            target="_blank"
            rel="noreferrer "
          >
            Nadège REY
          </a>{" "}
          . It is open-sourced on{" "}
          <a
            href="https://github.com/nRey32/rwapp"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            GitHub
          </a>{" "}
          and hosted on{" "}
          <a
            href="https://splendorous-croquembouche-9e03d9.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Netlify
          </a>
          .{" "}
        </footer>
      </div>
    </div>
  );
}
